module.exports = __webpack_public_path__ + "img/75657.0d981510.svg";